import React from 'react';
import './Sponsorships.css';

const Sponsorships = ({ isDarkMode = false }) => {
  // Import all images from the sponsorships directory
  const importAll = (r) => {
    let images = {};
    r.keys().forEach((item) => { 
      images[item.replace('./', '')] = r(item); 
    });
    return images;
  }
  
  // Import all jpg and png files from the sponsorships directory
  const sponsorImages = importAll(require.context('../assets/sponsorships', false, /\.(png|jpe?g)$/));
  
  // Convert the images object into an array and sort by filename
  const sponsors = Object.entries(sponsorImages)
    .filter(([filename]) => !filename.startsWith('.')) // Filter out hidden files like .DS_Store
    .sort((a, b) => {
      // Extract numbers from filenames and compare
      const numA = parseInt(a[0].match(/\d+/)?.[0] || '0');
      const numB = parseInt(b[0].match(/\d+/)?.[0] || '0');
      return numA - numB;
    })
    .map(([filename, image], index) => ({
      id: index + 1,
      image: image,
      name: `Sponsor ${index + 1}`
    }));

  return (
    <section className={`sponsorships ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <h2 className="sponsorships-title">We're Proud to Sponsor</h2>
      <div className="sponsors-grid">
        {sponsors.map((sponsor) => (
          <div key={sponsor.id} className="sponsor-item">
            <img 
              src={sponsor.image} 
              alt={`${sponsor.name} logo`}
              className="sponsor-logo"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Sponsorships; 